import {
  ObjectCondition,
  ObjectTrigger,
  SceneSocketState,
} from '@/../client-generator/generated-clients/plants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionSocket',
  components: {
    EnumToRadioButton,
  },
})
export default class TriggerAndConditionSocket extends SceneTriggerAndConditionGeneral {
  SceneSocketState = SceneSocketState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;

  get isConfirmEnabled() {
    return this.triggerOrActionToAdd.socketState != SceneSocketState.None;
  }
}
